import { render, staticRenderFns } from "./SenaEditionGamesPick.vue?vue&type=template&id=60d9e63c&"
import script from "./SenaEditionGamesPick.vue?vue&type=script&lang=js&"
export * from "./SenaEditionGamesPick.vue?vue&type=script&lang=js&"
import style0 from "./SenaEditionGamesPick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports